import { makeStyles } from "tss-react/mui";
import { AppTheme } from "@/theme";

export const useStyles = makeStyles()((theme: AppTheme) => ({
  root: {
    color: "inherit",
    display: "block",
    padding: theme.spacing(2, 3),
    border: "2px solid #eaeaea",
    borderRadius: 25,
    "&:hover": {
      textDecoration: "none",
      borderColor: "#458CFF",
      "& > $wrapper > $radioChecked": {
        display: "block",
      },
      "& > $wrapper > $radio": {
        display: "none",
      },
    },
  },
  radio: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  radioChecked: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  content: {
    marginLeft: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  wrapper: {},
  title: {
    fontWeight: 700,
  },
  description: {
    marginTop: theme.spacing(0.5),
  },
}));
